import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import PageSelector from 'components/PageSelector';
import { getMagazinePaging } from 'selectors';
import * as actions from 'actions';

export const MagazineArticlesListPageSelector = props => {
  const { query, queryString, ...otherProps } = props; //eslint-disable-line no-unused-vars
  return <PageSelector {...otherProps} />;
};

const mapStateToProps = (state, props) => {
  const { queryString } = props;
  return getMagazinePaging(state, 'magazineArticles', { queryString });
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onPrevClick: currentPage => {
      dispatch(actions.magazineArticlesFetch(currentPage - 1, props.query, props.queryString));
    },
    onNextClick: currentPage => {
      dispatch(actions.magazineArticlesFetch(currentPage + 1, props.query, props.queryString));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.magazineArticlesUpdatePossiblePage(newPossiblePage, props.queryString));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.magazineArticlesFetch(newPage, props.query, props.queryString));
      }
    }
  };
};

MagazineArticlesListPageSelector.propTypes = {
  query: PropTypes.object,
  queryString: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagazineArticlesListPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/MagazineArticlesList/MagazineArticlesListPageSelector/index.js
 **/